import classNames from 'classnames';
import React from 'react';
import { Chip, ChipColor } from '../../../../../components/Chip';
import { IconChip } from '../../../../../components/IconChip';
import {
  Session,
  SessionEvaluationStatus,
} from '../../../../../entities/training/Session';

interface PropTypes {
  className?: string;
  session: Session;
}

const ABSOLUTE_POSITION_CLASSES = classNames(
  'd-flex',
  'top-0',
  'end-0',
  'gap-2',
);

function isPendingEvaluation(status: SessionEvaluationStatus) {
  return (
    status === SessionEvaluationStatus.Submitted ||
    status === SessionEvaluationStatus.Pending
  );
}

function PendingEvaluationChip() {
  return <IconChip chipColor={ChipColor.Blue}>Pending Evaluation</IconChip>;
}

function CompletedChip() {
  return (
    <IconChip
      chipColor={ChipColor.Success}
      iconClass='bi bi-check-lg'
      iconPosition='right'
    >
      Completed
    </IconChip>
  );
}

function ComingSoonChip() {
  return <Chip color={ChipColor.Gray900}>Coming soon</Chip>;
}

function AssignedChip() {
  return <Chip color={ChipColor.Orange}>Assigned to you</Chip>;
}

export function SessionStatusChip(props: PropTypes) {
  return (
    <div className={classNames(ABSOLUTE_POSITION_CLASSES, props.className)}>
      {isPendingEvaluation(props.session.evaluation.status) && (
        <PendingEvaluationChip />
      )}
      {props.session.completed ? (
        <CompletedChip />
      ) : props.session.comingSoon ? (
        <ComingSoonChip />
      ) : (
        props.session.assigned && <AssignedChip />
      )}
    </div>
  );
}
